module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"DevTools":{"DevTools":"Dev Config","AutomateSessionChecks":"Session Never Expires","ShowBackground":"Show Background"}},"fr":{"DevTools":{"DevTools":"Dev Config","AutomateSessionChecks":"Session Never Expires","ShowBackground":"Show Background"}}}')
  delete Component.options._Ctor
}
